import { useQuery } from "@tanstack/react-query"
import { goalsActivityQuery } from "modules/campaigns/lib/goals/goalsActivityQuery"

export function useGoalsActivityQuery(...args: Parameters<typeof goalsActivityQuery>) {
  return useQuery(goalsActivityQuery(...args))
}
